import React, { useCallback, useEffect, useState } from 'react';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import SelectDropdown from 'components/base/select-dropdown';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { debounce } from 'utils/functions';
import { StoreItemType } from 'models/store-item.model';
import { ConversionListType } from 'models/pricing.model';

const IngredientSelct = ({
  value,
  setValue,
  type = 'ingredients'
}: {
  value: string;
  setValue: (item: StoreItemType) => void;
  type?: 'ingredients' | 'mixes';
}) => {
  const [search, setSearch] = useState('');
  const [ingredients, setIngredients] = useState<StoreItemType[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchIngredients = async (searchString: string) => {
    const url =
      type === 'ingredients'
        ? `ingredients`
        : 'ingredient-mix/cokitchen/fetch-mixes-with-ingredients';
    try {
      const response = await apiService.get(url, {
        params: { name: searchString, page: 1 },
        version: 'v2'
      });
      if (response) {
        setIngredients(
          response?.data?.data?.map((_: StoreItemType) => ({
            ..._,
            name: _?.name
          }))
        );
      }
    } catch (err: any) {
      toast(
        <ToastMessage
          message={err.response?.data?.message || 'Error fetching excel meals'}
          type='error'
        />
      );
    } finally {
      setLoading(false);
    }
  };
  const fetchMixes = async (searchString: string) => {
    try {
      const response = await apiService.get(
        'ingredient-mix/cokitchen/fetch-mixes-with-ingredients?page=1',
        {
          params: { name: searchString, page: 1 }
        }
      );
      if (response) {
        setIngredients(
          response?.data?.results?.map((_: ConversionListType) => ({
            ..._.ingredient,
            name: _?.ingredient?.name
          }))
        );
      }
    } catch (err: any) {
      toast(
        <ToastMessage
          message={err.response?.data?.message || 'Error fetching excel meals'}
          type='error'
        />
      );
    } finally {
      setLoading(false);
    }
  };

  const debounceFetchIngredients = useCallback(debounce(fetchIngredients, 500), []);
  const debounceFetchMixes = useCallback(debounce(fetchMixes, 500), []);

  useEffect(() => {
    setLoading(true);
    if (type === 'mixes') {
      debounceFetchMixes(search);
    } else {
      debounceFetchIngredients(search);
    }
  }, [search]);

  return (
    <SelectDropdown
      hasSearch
      placeholder='Search Ingredients'
      value={value}
      setValue={(item) => {
        setValue(item);
        setSearch('');
      }}
      onChange={(val) => {
        setSearch(val);
      }}
      options={ingredients}
      loading_options={loading}
    />
  );
};
export default IngredientSelct;
